import * as betsAPI from "app/api/betsApi";
import * as multipleBetsApi from "app/api/multiplesBetsApi";
import CurrencyNumber from "app/components/CurrencyNumber/CurrencyNumber";
import GeniusSiteTracking from "app/components/GeniusTracking/GeniusSiteTracking";
import LoadingSpinner from "app/components/LoadingSpinner/LoadingSpinner";
import { BetSlipHelper } from "app/helpers/betSlipHelper";
import { MultiplesHelper } from "app/helpers/multiplesHelper";
import { SessionHelper } from "app/helpers/sessionHelper";
import BetDrawerLogic from "app/logic/betDrawerLogic";
import store from "app/store/store";
import { BetSlipType } from "app/types/betSlipType";
import { MultiplesBetSlipType } from "app/types/multiplesBetSlipType";
import { UserType } from "app/types/userType";
import { BetSlipStates, OddsType } from "app/utils/const";
import isPublicView from "app/utils/publicViewUtils";
import cx from "classnames";
import debounce from "lodash/debounce";
import get from "lodash/get";
import groupBy from "lodash/groupBy";
import sortBy from "lodash/sortBy";
import { Component } from "react";
import { FormattedMessage, injectIntl, IntlShape } from "react-intl";
import { connect } from "react-redux";
import ReactTooltip from "react-tooltip";
import { v4 as uuidv4 } from "uuid";
import ENV from "../../../../../../../../../config";
import {
  IconBetDrawerEmpty,
  IconTrash,
} from "../../../../../../../../components/Icon/Icon";
import MultiplesBetSlip from "./components/MultiplesBetSlip/MultiplesBetSlip";
import MultiplesBetSlipCompleted from "./components/MultiplesBetSlipCompleted/MultiplesBetSlipCompleted";
import OddsDisplay from "./components/OddsDisplay/OddsDisplay";
import "./MultiplesBetSlipList.scss";

type Props = {
  multiplesBetSlipList: MultiplesBetSlipType[];
  multiplierName: string;
  maxStake: number;
  maxReturn: number;
  oddsTotal: number;
  message: string;
  clearMultiples: Function;
  validateMultiples: Function;
  canSubmit: boolean;
  setMultipleBetResponse: Function;
  setMultipleBetMessage: Function;
  setMultiplesBetSlipState: Function;
  status: string;
  multiplesBetSlipState: string;
  intl: IntlShape;
  multiplesBetSlipStake: number;
  multiplesBetSlipRequestedStake: number;
  multiplesBetSlipId: number;
  updateMultiplesBetSlip: Function;
  setIsOverMaxReturn: Function;
  isOverMaxReturn: boolean;
  potentialProfitMessage: string;
  setIsOverMaxStake: Function;
  stakeMessage: string;
  isOverMaxStake: boolean;
  updateMultiplesBetSlipList: Function;
  oddsType: string;
  resetOddsTotal: Function;
  fetchPricesForLegs: Function;
  decimalOdds: number;
  betSlipList: BetSlipType[];
  removeBetSlip: Function;
  multiplesBetSlipListBetsAddedCount: number;
  setLegAddedOrRemovedFalse: Function;
  legAddedOrRemoved: boolean;
  toggleShouldOverrideBetErrorMessage: Function;
  shouldOverrideBetErrorMessage: boolean;
  multiplesBetSlipListStatus: string;
  user: UserType;
};

type State = {
  stake: any;
  potentialProfit: number;
  isMouseInside: boolean;
  showAcceptOddsText: boolean;
  uimessage: string;
};

class MultiplesBetSlipList extends Component<Props, State> {
  inputElement: any;
  intervalId: any;
  statusPollIntervalId: number | null;
  constructor(props) {
    super(props);
    this.state = {
      stake: "",
      potentialProfit: 0,
      isMouseInside: false,
      showAcceptOddsText: false,
      uimessage: "",
    };
    this.getPotentialProfit = debounce(this.getPotentialProfit, 250);
    this.intervalId = null;
    this.statusPollIntervalId = null;
  }

  componentDidMount() {
    if (this.props.multiplesBetSlipList.length > 0 && !this.intervalId) {
      this.pollValidation();
    } else if (
      this.props.multiplesBetSlipList.length === 0 &&
      this.intervalId
    ) {
      clearInterval(this.intervalId);
      this.intervalId = null;
    }
    this.props.toggleShouldOverrideBetErrorMessage(false);
    if (this.props.legAddedOrRemoved) {
      this.props.setLegAddedOrRemovedFalse();
    }
  }

  // If odds change on any leg, then change the text on the Submit button
  // and show message
  setOddsChanged() {
    this.setState({
      showAcceptOddsText: true,
      uimessage: this.props.intl.formatMessage({
        id: "multiple-odds-changed",
      }),
    });
  }

  // Hide odds change message and reset button text when:
  // - leg added or removed
  // - bet placed
  // - multiple bet removed
  resetOddsChanged() {
    this.setState({ showAcceptOddsText: false });
    this.setState({ uimessage: "" });
  }

  handleMaxClick = () => {
    const { maxStake, decimalOdds, oddsTotal } = this.props;
    // Update the stake in the state and recalculate potential profit
    this.setState({ stake: maxStake }, () => {
      // Access the updated state and call getPotentialProfit with the latest values
      const { stake } = this.state;
      this.getPotentialProfit(stake, oddsTotal, decimalOdds);
    });
  };

  componentDidUpdate(prevProps, prevState) {
    const { decimalOdds, oddsTotal, maxStake } = this.props;
    const { stake } = this.state;

    if (this.props.multiplesBetSlipList.length > 0 && !this.intervalId) {
      this.pollValidation();
    }
    if (this.props.multiplesBetSlipList.length === 0 && this.intervalId) {
      clearInterval(this.intervalId);
      this.intervalId = null;
    }
    // Check if odds have changed, after api validation response
    if (decimalOdds !== prevProps.decimalOdds) {
      // Odds may change when:
      // - odds on one or more legs odds changes
      // - leg added or removed
      // Don't show ui Odds Changed message when the change in odds is the result of a leg added or removed
      if (!this.props.legAddedOrRemoved) {
        this.setOddsChanged();
      } else {
        this.props.setLegAddedOrRemovedFalse();
      }
    }
    // If true, a leg has been added or removed
    if (this.props.legAddedOrRemoved !== prevProps.legAddedOrRemoved) {
      this.resetOddsChanged();
    }

    // If odds have changed, need to update potential profit
    if (
      stake > 0 &&
      oddsTotal !== prevProps.oddsTotal &&
      this.props.multiplesBetSlipListStatus !== BetSlipStates.FINISHED
    ) {
      this.getPotentialProfit(Number(stake), Number(oddsTotal), decimalOdds);
    }
    if (prevProps.maxStake !== maxStake) {
      this.checkStakeIsLessThanMaxStake(stake, maxStake);
    }
    // BET-14634 Issue from switching from Malay/probability odds to US odds
    // prevents UI from displaying incorrect Malay odds
    if (
      (prevProps.oddsType === OddsType.MALAY ||
        prevProps.oddsType === OddsType.PROBABILITY) &&
      this.props.oddsType === OddsType.US
    ) {
      this.props.fetchPricesForLegs();
    }
  }

  componentWillUnmount() {
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
    this.stopPollingForUpdates();
    if (this.props.legAddedOrRemoved) {
      this.props.setLegAddedOrRemovedFalse();
    }
  }

  handleStakeInput = (inputValue: string) => {
    const { oddsTotal, maxStake, decimalOdds } = this.props;
    const value = Math.abs(Number(inputValue)).toString();
    // make sure the entered number is only positive
    this.updateStakeInput(value);
    this.getPotentialProfit(Number(value), Number(oddsTotal), decimalOdds);
    this.checkStakeIsLessThanMaxStake(Math.abs(Number(inputValue)), maxStake);
  };

  checkPotentialProfitIsLessThanMaxPayout(response) {
    if (response["potentialProfit"] > this.props.maxReturn) {
      this.props.setIsOverMaxReturn(true);
    } else {
      this.props.setIsOverMaxReturn(false);
    }
  }

  checkStakeIsLessThanMaxStake(stake: number, maxStake: number) {
    // If stake is greater than max stake, show error message and disable submit button
    if (stake > maxStake) {
      this.props.setIsOverMaxStake(true);
    } else {
      this.props.setIsOverMaxStake(false);
    }
  }

  updateStakeInput = (value: string) => {
    // Only allow numbers higher than zero
    // otherwise show placeholder
    this.setState({
      stake: Number(value) > 0 ? value : "",
    });
  };

  getPotentialProfit = (newStake: number, odd: number, decimalOdds: number) => {
    let oddsType = localStorage.getItem("oddsType") || "";
    // For MALAY odds send oddsType decimal
    const payloadOddsType =
      oddsType === OddsType.MALAY ? OddsType.DECIMAL : oddsType;
    const payloadOdds = oddsType === OddsType.MALAY ? decimalOdds : odd;

    // prevents call fetchPotentialProfit after bet complete
    !isNaN(odd) &&
      betsAPI
        .fetchPotentialProfit(newStake, payloadOdds, payloadOddsType)
        .then(response => {
          this.checkPotentialProfitIsLessThanMaxPayout(response);
          this.setState({
            potentialProfit: response["potentialProfit"],
          });
        });
  };

  pollValidation = () => {
    this.props.validateMultiples();
    this.intervalId = setInterval(() => {
      this.props.validateMultiples();
    }, 3000);
  };

  clearMultiples = () => {
    const { clearMultiples, toggleShouldOverrideBetErrorMessage } = this.props;
    // filter single  bets list removing all bets with corresponding runnerIds to multiple bets
    MultiplesHelper.removeCorrespondingSingleBets();
    // next clear all multiple bets
    BetSlipHelper.clearLocalStorageBetSlipLists();
    clearMultiples();
    clearInterval(this.intervalId);
    this.intervalId = null;
    this.stopPollingForUpdates(); // Stop polling for updates when bet slip is cleared
    this.props.setMultipleBetMessage("");
    this.resetOddsChanged();
    toggleShouldOverrideBetErrorMessage(false);
    this.setState({ stake: "" });
  };

  /**
   * Handles blocking the overwriting of the error message for a certain period of time after submitting a bet.
   * @returns {void}
   */
  handleBlockBetErrorMessage = () => {
    // block overwriting of message for 3 seconds after submitting bet
    this.props.toggleShouldOverrideBetErrorMessage(true);
    setTimeout(() => {
      // remove blocking after 3 seconds
      this.props.toggleShouldOverrideBetErrorMessage(false);
    }, 3000);
  };

  submitBet = (event: Event) => {
    if (isPublicView()) {
      event.preventDefault();
    }
    event.preventDefault();
    const { multiplesBetSlipList, canSubmit, oddsTotal } = this.props;
    const oddsType = localStorage.getItem("oddsType") || "";
    // check if can submit bet
    if (!canSubmit) {
      return;
    }
    const request_id = uuidv4();

    const multiplierBetLegs = multiplesBetSlipList.map(m => {
      return {
        odds: m.odds,
        runnerId: m["runnerId"],
        oddsType: m.oddsType,
      };
    });

    this.props.setMultipleBetMessage("");
    this.resetOddsChanged();
    this.props.setMultiplesBetSlipState(BetSlipStates.PENDING);
    this.intervalId && clearInterval(this.intervalId); //Stop validating the multiple legs
    this.intervalId = null;
    multipleBetsApi
      .placeMultiple(
        multiplierBetLegs,
        Number(this.state.stake),
        oddsType,
        request_id,
        oddsTotal
      )
      .then(resp => {
        const multipleBetResponse = get(resp, ["bets", 0]);
        this.startPollingForUpdates();
        if (multipleBetResponse) {
          this.props.setMultipleBetMessage(multipleBetResponse.message);
          // if submitted bet has status FAILED, then handleBlockBetErrorMessage() will be called
          multipleBetResponse.status === BetSlipStates.FAILED &&
            this.handleBlockBetErrorMessage();
          this.props.updateMultiplesBetSlip({ id: multipleBetResponse.id });
          const status = store.getState().multiplesBetSlipListModel.status;
          // Usually websocket update arrives before the resp to the post
          // so if it is already FINISHED, don't set it to PENDING ie the status that is returned from the POST
          if (status && status !== "FINISHED") {
            this.props.setMultiplesBetSlipState(multipleBetResponse.status);
          }
          // BET-17527 bug fix for multiple bets where API request is returned before websocket update
          if (
            multipleBetResponse &&
            (multipleBetResponse.status === BetSlipStates.PENDING ||
              status === undefined)
          ) {
            this.stopPollingForUpdates();
          }
        }

        if (
          multipleBetResponse &&
          multipleBetResponse.status === BetSlipStates.FAILED
        ) {
          console.log("FAILED multipleBetResponse: ", multipleBetResponse);
          this.props.setMultiplesBetSlipState(multipleBetResponse.status);
        }
        if (
          multipleBetResponse &&
          (multipleBetResponse.status === BetSlipStates.FINISHED ||
            multipleBetResponse.status === BetSlipStates.FAILED)
        ) {
          this.stopPollingForUpdates();
        }
      });
  };

  startPollingForUpdates = () => {
    this.statusPollIntervalId = window.setInterval(() => {
      this.getMultiplierBetStatus();
    }, 3000);
  };

  stopPollingForUpdates = () => {
    this.statusPollIntervalId && clearInterval(this.statusPollIntervalId);
  };

  getMultiplierBetStatus = () => {
    // Validate the bet up against the API

    const { multiplesBetSlipId } = this.props;
    if (multiplesBetSlipId) {
      betsAPI
        .validateBetSlip(multiplesBetSlipId) //TODO this endpoint doesnt work for multiples
        .then(bet => {
          BetDrawerLogic.updateBetSlipFromBet(bet);
          if (
            bet.status === BetSlipStates.FINISHED ||
            bet.status === BetSlipStates.FAILED
          ) {
            this.stopPollingForUpdates();
          }
        })
        .catch(error => {
          throw error;
        });
    }
  };

  /**
   * Determines whether the tooltip should be displayed for multiple bets.
   * The tooltip should be displayed if there are more than one bet in the multiples bet slip list.
   *
   * @returns {boolean} True if the tooltip should be displayed, false otherwise.
   */
  shouldDisplayToolTipForMultipleBets = () => {
    return this.props.multiplesBetSlipList?.length > 1 || false;
  };

  render: () => any | null | Node = () => {
    const {
      multiplesBetSlipList,
      multiplierName,
      maxStake,
      oddsTotal,
      message,
      canSubmit,
      multiplesBetSlipState,
      multiplesBetSlipStake,
      multiplesBetSlipRequestedStake,
      isOverMaxReturn,
      isOverMaxStake,
      oddsType,
      decimalOdds,
      shouldOverrideBetErrorMessage,
    } = this.props;
    const isPending =
      multiplesBetSlipState === BetSlipStates.PENDING ||
      multiplesBetSlipState === BetSlipStates.PROCESSING;
    const sortedMultiplesList = sortBy(multiplesBetSlipList, ["message"]);
    const multiplesBetSlipsGroupedByEvent = groupBy(
      sortedMultiplesList,
      "translatedName"
    );

    const isFinished = this.props.status === BetSlipStates.FINISHED;
    return (
      <div className="multiples-container">
        {isFinished ? (
          <MultiplesBetSlipCompleted />
        ) : (
          <div className="multiples-bet-slip-list">
            {multiplesBetSlipList && multiplesBetSlipList.length > 0 ? (
              <div className="bet-drawer__list">
                {isPending && (
                  <LoadingSpinner
                    spinner="bar"
                    text={this.props.intl.formatMessage({
                      id: "bets-betslip-submission-in-progress",
                    })}
                    data={this.props}
                    oddsType={localStorage.getItem("oddsType") || ""}
                    selectedOdd={0}
                    betSlipOdd={{
                      stake: multiplesBetSlipStake,
                      requestedStake: multiplesBetSlipRequestedStake,
                    }}
                  />
                )}
                {Object.keys(multiplesBetSlipsGroupedByEvent).map(
                  (betslipgroup, index) => {
                    if (
                      multiplesBetSlipsGroupedByEvent[betslipgroup].length > 0
                    ) {
                      return (
                        <MultiplesBetSlip
                          multiplesBetSlipList={
                            multiplesBetSlipsGroupedByEvent[betslipgroup]
                          }
                          key={index}
                        />
                      );
                    } else {
                      return null;
                    }
                  }
                )}

                <div
                  className={cx("multiples-bet-slip-list__totals-wrapper", {
                    "multiples-bet-slip-list__totals-wrapper--asian":
                      SessionHelper.isAsianRouteAndSessionView(),
                  })}
                >
                  <div className="multiples-bet-slip-list__totals">
                    <div className="multiples-bet-slip-list__totals__message">
                      <span>{message}</span>
                      {this.props.multiplesBetSlipList &&
                      this.props.multiplesBetSlipList.length < 2 ? null : (
                        <span>{this.state.uimessage}</span>
                      )}
                    </div>
                    {isOverMaxReturn && (
                      <div className="multiples-bet-slip-list__totals__message">
                        <FormattedMessage
                          id="multiples-max-return-message"
                          values={{
                            maxReturn: (
                              <CurrencyNumber value={this.props.maxReturn} />
                            ),
                          }}
                        />
                      </div>
                    )}
                    {isOverMaxStake && !isPublicView() && (
                      <div className="multiples-bet-slip-list__totals__message">
                        <FormattedMessage
                          id="multiples-max-stake-message"
                          values={{
                            maxStake: <CurrencyNumber value={maxStake} />,
                          }}
                        />
                      </div>
                    )}
                    <div className="multiples-bet-slip-list__totals__top">
                      <span>{multiplierName}</span>
                      {this.shouldDisplayToolTipForMultipleBets() && (
                        <>
                          <span className="multiples-bet-slip-list__odds-container">
                            <span
                              className="multiples-bet-slip-list__odds-container__info-icon"
                              data-tip
                              data-for="oddsMessage"
                            >
                              {"i"}
                            </span>

                            <OddsDisplay
                              odds={oddsTotal}
                              multiplesOddsType={oddsType}
                              decimalOdds={decimalOdds}
                              legAddedOrRemoved={this.props.legAddedOrRemoved}
                            />
                          </span>
                        </>
                      )}
                    </div>
                    <div className="multiples-bet-slip-list__totals__bottom">
                      <div
                        className={`multiples-bet-slip-list__input-stake ${
                          this.props.multiplesBetSlipList &&
                          this.props.multiplesBetSlipList.length < 2
                            ? "disabled"
                            : ""
                        }`}
                      >
                        <label className="multiples-bet-slip-list__input-stake__container">
                          <span className="multiples-bet-slip-list__input-stake__label">
                            <FormattedMessage
                              tagName="span"
                              id="reports-stake"
                            />
                          </span>
                          <form onSubmit={this.submitBet} action="">
                            <input
                              type="number"
                              pattern="[0-9]*"
                              min={0}
                              ref={ref => {
                                this.inputElement = ref;
                              }}
                              className="multiples-bet-slip-list__input-stake__input"
                              value={this.state.stake}
                              onChange={event =>
                                this.handleStakeInput(event.target.value)
                              }
                              placeholder="0"
                              onWheel={e => {
                                this.inputElement.blur();
                              }}
                              onKeyDown={event => {
                                if (isPublicView() && event.key === "Enter") {
                                  event.preventDefault();
                                }
                              }}
                              disabled={
                                this.props.multiplesBetSlipList &&
                                this.props.multiplesBetSlipList.length < 2
                              } // Disabling the input based on condition
                            />
                          </form>
                        </label>
                      </div>

                      <div className="multiples-bet-slip-list__return-container">
                        <span className="multiples-bet-slip-list__return-container__return">
                          <FormattedMessage tagName="span" id="bets-return" />
                          <CurrencyNumber
                            className={
                              "multiples-bet-slip-list__return-container__profit"
                            }
                            value={this.state.potentialProfit || 0}
                          />
                        </span>
                      </div>
                    </div>
                    {isPublicView() ? (
                      <div className="multiples-bet-slip-list__totals__max-stake">
                        &nbsp;
                      </div>
                    ) : (
                      <div className="multiples-bet-slip-list__totals__max-stake">
                        <FormattedMessage
                          tagName="span"
                          id="events-graphmaxstake"
                        />
                        {":"}
                        <div onClick={this.handleMaxClick}>
                          <CurrencyNumber
                            className={
                              "multiples-bet-slip-list__return-container__profit"
                            }
                            value={maxStake || 0}
                          />
                        </div>
                      </div>
                    )}

                    <div className="multiples-bet-slip-list__totals__buttons">
                      <button
                        type="submit"
                        className="multiples-bet-slip-list__submit-button"
                        disabled={
                          !this.state.stake ||
                          !canSubmit ||
                          this.props.isOverMaxReturn ||
                          this.props.isOverMaxStake ||
                          this.props.legAddedOrRemoved
                        }
                        onClick={(e: any) => {
                          // update onClick event to accommodate public view
                          if (isPublicView()) {
                            // redirect to login page of customer site
                            return window.location.replace(
                              ENV.MAIN_SITE_URL + "/login"
                            );
                          }
                          return this.submitBet(e);
                        }}
                      >
                        {this.state.showAcceptOddsText ? (
                          <FormattedMessage
                            tagName="span"
                            id={`${
                              isPublicView()
                                ? "public-view-place-multiple-bet"
                                : "accept-&-place-bet"
                            }`}
                          />
                        ) : (
                          <FormattedMessage
                            tagName="span"
                            id={`${
                              isPublicView()
                                ? "public-view-place-multiple-bet"
                                : "place-multiple-bet"
                            }`}
                          />
                        )}
                      </button>
                      <button
                        onClick={this.clearMultiples}
                        className="multiples-bet-slip-list__remove-button"
                      >
                        <IconTrash />
                      </button>
                      <GeniusSiteTracking
                        accountID={this.props.user.accountId}
                        targetSelector={`.multiples-bet-slip-list__submit-button`}
                        eventType="click"
                        pageName="betconfirm"
                        // value={oddsValue}
                        currency={this.props.user.currencyCode}
                        trackPageLoad={false}
                      />
                    </div>
                    {this.shouldDisplayToolTipForMultipleBets() && (
                      <ReactTooltip
                        id="oddsMessage"
                        className="odds-message"
                        place="bottom"
                        type="dark"
                      >
                        <FormattedMessage
                          tagName="span"
                          id="bets-mutiple-odds-message"
                        />
                      </ReactTooltip>
                    )}
                  </div>
                </div>
              </div>
            ) : (
              <div className="bet-drawer__empty-list">
                <IconBetDrawerEmpty />
                <span className="bet-drawer__empty-list__text">
                  <FormattedMessage
                    tagName="span"
                    id="bets-empty-betslip-text"
                  />
                </span>
              </div>
            )}
          </div>
        )}
      </div>
    );
  };
}

const mapStateToProps = state => ({
  user: state.userModel.user,
  multiplesBetSlipList: state.multiplesBetSlipListModel.multiplesBetSlipList,
  legAddedOrRemoved: state.multiplesBetSlipListModel.legAddedOrRemoved,
  multiplierName: state.multiplesBetSlipListModel.multiplierName,
  maxStake: state.multiplesBetSlipListModel.maxStake,
  maxReturn: state.multiplesBetSlipListModel.maxReturn,
  oddsTotal: state.multiplesBetSlipListModel.oddsTotal,
  decimalOdds: state.multiplesBetSlipListModel.decimalOdds,
  message: state.multiplesBetSlipListModel.message,
  canSubmit: state.multiplesBetSlipListModel.canSubmit,
  status: state.multiplesBetSlipListModel.status,
  multiplesBetSlipState: state.multiplesBetSlipListModel.multiplesBetSlipState,
  multiplesBetSlipRequestedStake:
    state.multiplesBetSlipListModel.multiplesBetSlipRequestedStake,
  multiplesBetSlipStake: state.multiplesBetSlipListModel.multiplesBetSlipStake,
  multiplesBetSlipId: state.multiplesBetSlipListModel.id,
  isOverMaxReturn: state.multiplesBetSlipListModel.isOverMaxReturn,
  potentialProfitMessage:
    state.multiplesBetSlipListModel.potentialProfitMessage,
  stakeMessage: state.multiplesBetSlipListModel.stakeMessage,
  isOverMaxStake: state.multiplesBetSlipListModel.isOverMaxStake,
  oddsType: state.userModel.user.preferences.oddsType,
  betSlipList: state.betSlipListModel.betSlipList,
  multiplesBetSlipListBetsAddedCount:
    state.multiplesBetSlipListModel.multiplesBetSlipListBetsAddedCount,
  shouldOverrideBetErrorMessage:
    state.multiplesBetSlipListModel.shouldOverrideBetErrorMessage,
  multiplesBetSlipListStatus: state.multiplesBetSlipListModel.status,
});

const mapDispatchToProps = dispatch => ({
  clearMultiples: () => {
    dispatch.multiplesBetSlipListModel.clearMultiples();
  },
  setLegAddedOrRemovedFalse: () => {
    dispatch.multiplesBetSlipListModel.setLegAddedOrRemovedFalse();
  },
  resetOddsTotal: () => {
    dispatch.multiplesBetSlipListModel.resetOddsTotal();
  },
  fetchPricesForLegs: () => {
    dispatch.multiplesBetSlipListModel.fetchPricesForLegs();
  },
  validateMultiples: () =>
    dispatch.multiplesBetSlipListModel.validateMultiples(),
  setMultipleBetResponse: (status: string) =>
    dispatch.multiplesBetSlipListModel.setMultipleBetResponse(status),
  setMultipleBetMessage: (message: string) =>
    dispatch.multiplesBetSlipListModel.setMultipleBetMessage(message),
  setMultiplesBetSlipState: (multiplesBetSlipState: string) =>
    dispatch.multiplesBetSlipListModel.setMultiplesBetSlipState(
      multiplesBetSlipState
    ),
  updateMultiplesBetSlipList: (payload: any) =>
    dispatch.multiplesBetSlipListModel.updateMultiplesBetSlipList(payload),
  updateMultiplesBetSlip: (payload: any) =>
    dispatch.multiplesBetSlipListModel.updateMultiplesBetSlip(payload),
  setIsOverMaxReturn: (payload: boolean) =>
    dispatch.multiplesBetSlipListModel.setIsOverMaxReturn(payload),
  setIsOverMaxStake: (payload: boolean) =>
    dispatch.multiplesBetSlipListModel.setIsOverMaxStake(payload),
  removeBetSlip: localId => dispatch.betSlipListModel.removeBetSlip(localId),
  toggleShouldOverrideBetErrorMessage: (
    shouldOverrideBetErrorMessage: boolean
  ) =>
    dispatch.multiplesBetSlipListModel.toggleShouldOverrideBetErrorMessage(
      shouldOverrideBetErrorMessage
    ),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(injectIntl(MultiplesBetSlipList)) as any;
